const onError = (errors, e) => console.log(errors, e);
export {
  onError
};
